// frontend/src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import './features/userHome/styles/homeusers.css';

// Componente de depuración temporal para mostrar errores
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Aquí puedes enviar el error a un servicio de log como Sentry o LogRocket
    console.error("Uncaught Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Muestra una interfaz de usuario de respaldo si ocurre un error
      return (
        <div style={{ padding: '20px', color: 'red', whiteSpace: 'pre-wrap' }}>
          <h2>❌ Error crítico en la aplicación</h2>
          <p>La aplicación ha fallado al iniciarse o al renderizar. Esto puede deberse a:</p>
          <ul>
            <li>Un error en la lógica de un componente.</li>
            <li>Problemas con las dependencias de React/Zustand.</li>
            <li>Una inicialización incorrecta del store.</li>
          </ul>
          <h3>Detalles del Error:</h3>
          <p>{this.state.error && this.state.error.toString()}</p>
          <h3>Component Stack Trace:</h3>
          <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);